import auditBasics from './auditBasics.vue';
import flowNode from './flowNode.vue';
import whiteList from './whiteList.vue';
export default {
  components: {
    auditBasics,
    flowNode,
    whiteList
  },
  data() {
    return {
      activeKey: 1,
      id: this.$route.params.id,
      timer1: 1,
      timer2: 2,
      timer3: 3
      // id:1771
    };
  },
  methods: {
    handleOk(val) {
      if (val) {
        this.id = val.auditFlowId;
      }
      this.activeKey = this.activeKey + 1;
      this.callback(this.activeKey);
    },
    tabChange(val) {
      if (this.$route.params.id == -1) {
        return false;
      }
      this.activeKey = val;
      this.callback(val);
    },
    backFun() {
      this.activeKey = this.activeKey - 1;
      this.callback(this.activeKey);
    },
    callback(key) {
      if (key == 1) {
        this.timer1 = new Date().getTime();
      } else if (key == 2) {
        this.timer2 = new Date().getTime();
      } else {
        this.timer3 = new Date().getTime();
      }
    }
  }
};